import { axiosInstance } from '../api';

export default function() {
    return axiosInstance.get('/fhir/ResearchStudy?status=suspended&_sort=-_lastUpdated&_count=50');
}
